// extracted by mini-css-extract-plugin
export default {"tab":"fRvir76VhdSMVgaBFot6","activeTab":"M1aE4fgOzRnXnzsSVikc","bounce":"Xu0Ye5wMIWuPPMJJwyp4"};